import React from "react";
import {Controller} from "react-hook-form";
import {TextField} from "@material-ui/core";


interface  iTextFieldController {
   name: string,
   control: any,
   defaultValue?: string,
   label?: string,
   rules?: object,
   options?: object,
   optionString?: string,
    fullWidth?: boolean
}

const TextFieldController = (props: iTextFieldController ) => {
    return (
        <Controller
            name={props.name}
            control={props.control}
            defaultValue={props.defaultValue}
            rules={{...props.rules}}
            render={ ({ field }) => <TextField variant="standard" fullWidth={props.fullWidth}  {...props.optionString} inputProps={{...props.options}} InputProps={{...props.options}} {...field} label={props.label} /> }
        />
    );
}


export default (TextFieldController);

